export default __webpack_public_path__ + "static/media/4T0A9464.02e26470.jpg";